// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#how-to-get-missions img{max-width:100%}#how-to-get-missions svg{border:3px solid #104182;border-radius:35%;height:auto;margin:0 auto 1rem;stroke:#104182;padding:1rem;width:30%}@media (min-width: 992px){#how-to-get-missions svg{padding:2rem;width:50%}}\n", ""]);
// Exports
module.exports = exports;
